import { useEffect, useState } from "react";
import { useAppContext } from "../context/AppContext";
import Page from "./Page";

const Module = ({ pageData }) => {
    const { activeIdx, setActiveIdx } = useAppContext();
    const [ isLoaded, setIsLoaded ] = useState(false);

    useEffect(() => {
        if (activeIdx === null) {
            setActiveIdx(0);
            setIsLoaded(true);
        }
    }, [activeIdx, setActiveIdx]);

    function onPrevious(ev) {
        ev.preventDefault();
        if (pageData.length && activeIdx > 0) {
            setActiveIdx(activeIdx - 1);
            window.scrollTo(0, 0);
        }
    }

    function onNext(ev) {
        ev.preventDefault();

        if (pageData.length && activeIdx + 1 < pageData.length) {
            setActiveIdx(activeIdx + 1);
            window.scrollTo(0, 0);
        }
    }

    if (!pageData.length) {
        return null;
    }

    return (
      <div className="module-container">
        <div className="module">
          {isLoaded && <Page data={pageData[activeIdx]} />}

          {pageData.length > activeIdx + 1 && (
            <div className="button-nav">
              <div className="button-wrapper">
                <button
                  onClick={onPrevious}
                  disabled={activeIdx > 0 ? false : true}
                  style={{
                    visibility: activeIdx === 0 ? `hidden` : `visible`,
                  }}
                >
                  &#60; Previous
                </button>
                <button onClick={onNext}>
                  {activeIdx === pageData.length - 2 ? `Take the quiz` : `Next`}{" "}
                  &#62;
                </button>
              </div>
            </div>
          )}
        </div>
      </div>
    );
};

export default Module;
